module.exports = __webpack_public_path__ + "img/sh.c4cd6642.svg";